export default "//file.bilionpass.com/japandx-web/0.0.1/static/empty-goods.4faf2292-95ebe8.svg";